import { rockSolidNutritionProject } from './rockSolidNutrition';
import { pakaProject } from './paka';
import { docOfDetoxProject } from './docOfDetox';
import { luxHairNycProject } from './luxHairNyc';
import { fineScentsProject } from './fineScents';
import { craftoriaProject } from './craftoria';

export const projectsList = [
    rockSolidNutritionProject,
    pakaProject,
    docOfDetoxProject,
    luxHairNycProject,
    fineScentsProject,
    craftoriaProject,
];
